import { useState, useEffect } from 'react';
import { useQuery } from '@tanstack/react-query';
import { systemLogsService, SystemLogQuery, SystemLogResponse } from '../systemLogsService';

export function useSystemLogs(query: SystemLogQuery = {}) {
  const [currentQuery, setCurrentQuery] = useState<SystemLogQuery>(query);

  const {
    data,
    isLoading,
    error,
    refetch,
  } = useQuery<SystemLogResponse>({
    queryKey: ['systemLogs', currentQuery],
    queryFn: () => systemLogsService.getSystemLogs(currentQuery),
    staleTime: 30000, // 30 seconds
  });

  const updateQuery = (newQuery: Partial<SystemLogQuery>) => {
    setCurrentQuery(prev => ({ ...prev, ...newQuery, nextToken: undefined }));
  };

  const loadMore = () => {
    if (data?.nextToken) {
      setCurrentQuery(prev => ({ ...prev, nextToken: data.nextToken }));
    }
  };

  const resetQuery = () => {
    setCurrentQuery(query);
  };

  return {
    logs: data?.logs || [],
    total: data?.total || 0,
    hasMore: !!data?.nextToken,
    isLoading,
    error,
    refetch,
    updateQuery,
    loadMore,
    resetQuery,
    currentQuery,
  };
} 